module.exports = __webpack_public_path__ + "static/media/cgi_logo.62008887.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/cgi_logo.svg
// module id = 775
// module chunks = 0